import { StatePreV6, StateV6 } from './6_migrate_rdb_tb_to_vorteilsrabatt.interface';

export const migrateRbdTbForVorteilsrabatte = (
  previousState: StatePreV6,
  newVersion: number,
  currentState: StateV6,
): StateV6 => {
  const isFtVorteilsRabatt = currentState.transientState.featureToggles['VORTEILSRABATT'];
  if (isFtVorteilsRabatt) {
    previousState.rbd = [];
    previousState.treuebonus = [];
  }
  return {
    ...previousState,
    version: newVersion,
  } as StateV6;
};
